import styled from "styled-components"
import theme from "styles/theme-main"

export const Wrapper = styled.div`
  display: inline-block;
  position: relative;
`
export const DisplayFlex = styled.div`
  display: flex;
`

export const Title = styled.h3`
  margin: 0 0 10px 0;
  text-align: left;
`

export const UL = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  font-size: 15px;
  color: #adb1b5;
  text-align: left;
`

export const LI = styled.li`
  font-size: 15px;
  color: #adb1b5;
  cursor: pointer;
  padding-left: 3px;
  ${props =>
    props.selected ? "background-color: #adb1b5;\ncolor: #ffffff;" : ""}

  &:hover {
    background-color: #adb1b5;
    color: #ffffff;
  }
`

export const IconWrapper = styled.div`
  width: 18px;
  height: 18px;
  margin-right: 9px;
  padding: 5px 0 0 0;
`

export const Link = styled.div`
  border-bottom: 1px dotted ${theme.buttons.border2};
`

export const Trigger = styled.div`
  display: flex;
  justify-content: space-between;
  color: #adb1b5;
  margin-left: 0;
  margin-right: 30px;
  text-decoration: none;
  cursor: pointer;
`

export const Separator = styled.div`
  margin-right: 30px;
  color: #adb1b5;

  @media (max-width: 800px) {
    display: none;
  }
`

export const DropDownWrapper = styled.div`
  display: ${props => (props.showDropdown ? "block" : "none")};
  position: absolute;
  background-color: #ffffff;
  border-radius: 20px;
  border: 1px solid #adb1b5;
  color: #adb1b5;
  font-size: 14px;
  padding: 13px 15px;
  bottom: 30px;
  width: 172px;
`
